import { render } from "./IndovinaBandieraView.vue?vue&type=template&id=5a2a07e8&class=template"
import script from "./IndovinaBandieraView.vue?vue&type=script&lang=js"
export * from "./IndovinaBandieraView.vue?vue&type=script&lang=js"

import "./IndovinaBandieraView.vue?vue&type=style&index=0&id=5a2a07e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__